import { AiInterviewQuestion } from './ai-interview-question.model';
import { AIInterviewTone } from './ai-interview-tone.enum';

export class ProjectAiInterviewContent {
  interviewUrl?: string;
  externalId?: string;
  interviewerName: string;
  interviewTone: AIInterviewTone;
  companyName: string;
  researchObjective: string;
  context: string;
  targetAudience: string;
  questions: AiInterviewQuestion[];
  openingMessage?: string;
}

export const isAiInterviewReadyToLaunch = (content: ProjectAiInterviewContent, targetCompletes: number): boolean =>
  content?.questions?.length > 0 && targetCompletes > 0 && !!content.openingMessage;
